export default __webpack_public_path__ + "static/media/drone.48571d77.svg";